export default {
  validFilters(state) {
    const obj = {};

    for (const [key, value] of Object.entries(state.filters)) {
      if (value) {
        obj[key] = value;
      }
    }

    return obj;
  },
};
